import { useMemo, useRef } from 'react';
import { useAuth } from 'react-oidc-context';

import { createApiClient, type ApiClient } from './client';

/**
 * Returns a stable ApiClient that injects the current OIDC access token at
 * request time. The client is created once per session so TanStack Query keys
 * stay stable, and a ref holds the latest token so the middleware always reads
 * fresh credentials after silent renewal.
 */
export function useApiClient(): ApiClient {
  const auth = useAuth();
  const tokenRef = useRef<string | null>(null);
  tokenRef.current = auth.user?.access_token ?? null;

  return useMemo(() => createApiClient(() => tokenRef.current), []);
}
